import React from 'react';

export const heroHome = {
  image: '/images/home/hero.png',
  image_mobile: '/images/home/hero-mobile.png',
  imageAlt:
    'High quality eyecare products, backed by science, without the price tag.',
  title: (
    <>
      Grow your practice&nbsp;
      <span className="underline block lg:inline">with WALDO</span>
    </>
  ),
  desc: (
    <>
      Patients are choosing WALDO because they want quality lenses for less.
      Doctors are choosing WALDO to increase revenue and improve capture rate.
    </>
  ),
  buttonLabel: 'GET IN TOUCH',
  buttonLink: '',
};
